import { Box, Button, Typography, styled } from '@mui/material'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import { useMemo, useState } from 'react'
import PaymentSettingSelectorDialog from './PaymentSettingSelectorDialog'
import {
    MapPaymentIcon,
    mapPaymentTypeName,
} from 'components/MapPaymentIcon/mapPaymentIcon'
import { PaymentSettingContract } from 'models'

export const DisplayPaymentType = ({
    paymentSetting: paymentType,
}: {
    paymentSetting: PaymentSettingContract
}) => {
    return (
        <Box display={'inline-flex'}>
            <MapPaymentIcon
                size={24}
                customLogoUrl={paymentType.customLogoUrl!}
                paymentTypeId={paymentType.paymentTypeID!}
            ></MapPaymentIcon>
            <Typography px={1}>
                {mapPaymentTypeName(paymentType.paymentTypeID!, true, {
                    paymentSetting: paymentType,
                })}
            </Typography>
        </Box>
    )
}

const PaymentButton = styled(Button)(({ theme }) => ({
    backgroundColor: theme.palette.topside.paper,
    '&:hover': {
        backgroundColor: theme.palette.topside.paper,
    },
    color: theme.palette.primary.main,
    minWidth: 120,
    maxWidth: 180,
    borderColor: theme.palette.primary.main,
}))

function PaymentSettingSelector() {
    const {
        paymentTypeLists,
        selectedPaymentType,
        onSelectPaymentType,
        expectAmount,
    } = usePaymentContext()

    const [openDialog, setOpenDialog] = useState<boolean>(false)

    const selectPaymentTypeName = useMemo(() => {
        if (!selectedPaymentType) return 'Not available'
        return <DisplayPaymentType paymentSetting={selectedPaymentType} />
    }, [selectedPaymentType])

    if (selectedPaymentType)
        return (
            <>
                <PaymentButton onClick={() => setOpenDialog(true)}>
                    <Typography noWrap color="primary" textOverflow="ellipsis">
                        {selectPaymentTypeName}
                    </Typography>
                </PaymentButton>

                {openDialog && (
                    <PaymentSettingSelectorDialog
                        paymentTypeSettings={paymentTypeLists}
                        onClose={() => setOpenDialog(false)}
                        onSelectPaymentType={onSelectPaymentType}
                        expectAmount={expectAmount.toNumber()}
                    />
                )}
            </>
        )
    else return <></>
}
export default PaymentSettingSelector
